import FilterSelect, {
    FilterSelectOptionType,
} from "@jmc/solid-design-system/src/components/molecules/FilterSelect/FilterSelect";
import React from "react";
import { useTranslation } from "react-i18next";

import { useLocatorContext } from "../LocatorContext/LocatorContext";
import { DistanceFilterType } from "../types/DistanceFilterType";
import kmToMiles from "../utils/kmToMiles";

type Props = {
    distanceLabel: "km" | "mi";
};

const DISTANCES = [30000, 20000, 15000, 10000, 5000];

const DistanceFilter = (props: Props): JSX.Element => {
    const { distanceLabel } = props;
    const { t } = useTranslation();
    const { distanceFilter, setDistanceFilter } = useLocatorContext();

    let selectedOptionCount = 0;
    const options = DISTANCES.map((item: number) => {
        const isSelected = item.toString() === distanceFilter?.value;
        if (isSelected) selectedOptionCount++;

        return {
            label: `${item / 1000}${distanceLabel}`,
            value: distanceLabel == "km" ? item.toString() : kmToMiles(item).toString(),
            isSelected: isSelected,
        };
    });

    return (
        <FilterSelect
            id="Distance"
            key={0}
            customClass={null}
            placeholder={
                selectedOptionCount > 0
                    ? `${t("Distance", { ns: "common" })} (${selectedOptionCount})`
                    : `${t("Distance", { ns: "common" })}`
            }
            options={options}
            isMulti={false}
            clickAction={(item: FilterSelectOptionType) => {
                setDistanceFilter(item as DistanceFilterType);
            }}
        />
    );
};

export default DistanceFilter;
